<template>
  <div class="main-content-container container-fluid h-100" style="padding:0px !important;">
    <div class="header-Panel btn-accent">
      <img
        id="main-logo"
        class="d-inline-block align-top mr-1"
        style="max-width: 80px;"
        src="@/assets/images/logo.png"
        alt="Dev Tool"
      />
      <label
        style="padding:20px; padding-left:5px; font-weight:500; font-size:20px !important;"
      >Dev Tool</label>
    </div>
    <div class="row h-80 no-gutters">
      <div class="auth-form mx-auto my-auto col-md-6 col-lg-4">
        <div class="card">
          <d-card-header class="border-bottom">
            <img
              id="main-logo"
              class="d-inline-block align-top mr-1"
              style="max-width: 50px;"
              src="@/assets/images/logo.png"
              alt="Dev Tool"
            />
            <strong class="s2" style="font-size:25px">OTP Verification</strong>
          </d-card-header>
          <div class="card-body">
            <!---->
            <!---->
            <!-- <img rc="/demo/shards-dashboard-vue/img/shards-dashboards-logo.60a85991.svg" alt="Dev Tools - OTP Template" class="auth-form__logo d-table mx-auto mb-3"/> -->
            <!-- <h5 class="auth-form__title text-center mb-4"> OTP </h5> -->
            <div class></div>
            <p>Please enter the 4-digit verification code we sent via SMS:</p>
            <label class="OTPClass" for="exampleInputPassword1">OTP</label>
            <div id="divOuter" style="margin-left:100px">
              <div id="divInner ">
                <input
                  id="partitioned"
                  type="text"
                  v-model="OTP.DataModel.Data.OTP.OTP"
                  maxlength="4"
                  autocomplete="off"
                />
              </div>
            </div>

            <!-- <div class="form-group">
                            <label class="OTPClass" for="exampleInputPassword1" >OTP</label>
                            <input style="width:100% !important" id="exampleInputPassword1" v-model="OTP.DataModel.Data.Password" type="password" placeholder="Password" class="form-control" />
            </div>-->

            <!-- <div class="form-group mb-3 d-table mx-auto">
                <label class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    autocomplete="off"
                    id="dr-checkbox-916cfc04-2baf-469b-a56a-26ccbea8ce08"
                    true-value="orange"
                    class="custom-control-input"
                    value="orange"
                  />
                  <label
                    for="dr-checkbox-916cfc04-2baf-469b-a56a-26ccbea8ce08"
                    aria-hidden="true"
                    class="custom-control-label"
                  ></label>
                  <span class="custom-control-description">Remember me for 30 days.</span>
                </label>
            </div>-->
            <button
              @click="Verify()"
              class="btn btn-pill btn-accent d-table mx-auto"
              style="margin-top:40px;border-radius:10px"
            >VERIFY NOW</button>

            <p
              @click="forgetpasswordClicks()"
              target="_self"
              style="margin-left:105px;margin-top:45px;color: rgb(0, 123, 255); cursor:pointer;"
            >Did not receive the code?</p>
            <!-- <div class="form-group">
                            <label for="email">Type in the characters displayed in the box below</label>
                              <img src="" id="captcha_image" />
                            <input type="text" class="form-control" required id="captcha" name="captcha">
            </div>-->
            <!-- <div class="row">
                            <button type="submit" @click="OTPClick()" class="btn btn-pill btn-accent d-table mx-auto">Submit</button>
                            <button type="submit" class="btn btn-pill btn-accent d-table mx-auto">Reset</button>
            </div>-->
          </div>

          <!-- <div class="border-top card-footer">

                    <div class="auth-form__meta d-flex">
                        <a style="color: rgb(0, 123, 255); cursor:pointer;" @click="forgetpasswordClick()" target="_self">Forgot your password?</a>

                        <a href="#" @click="Register()" class="ml-auto" target="_self">Registration</a>
                    </div>
          </div>-->
        </div>
        <!-- <div class="auth-form__meta d-flex mt-4">

        </div>-->
      </div>
    </div>
  </div>
</template>

<script src="https://checkout.razorpay.com/v1/checkout.js"></script>
<script>
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
export default {
  name: "OTP",
  data() {
    return {
      OTP: {
        PageType: "Master", // Master, Transaction, Dashboard, Tabb edDashboard
        PageLoad: true, // block/none
        DataModel: {
          Data: {
            OTP: {
              Id: 0,
              OTP: null
            },
            UserId: 0,
            UserName: null,
            Password: null,
            CreatedBy: null
          },
          UIData: {}
        },
        PageState: "Default", // Default, Changed/Dirty, Submitted, PageLoading Dirty means some values are changed in the page
        TabInfo: {
          SelectedTabIndex: 0,
          NumberOfTabs: 0
        },
        SessionInfo: {
          SessionTimeout: false,
          AuthToken: "",
          SessionID: "",
          PageInfo: {
            ClientId: 0,
            userId: 0,
            WareHouseId: 0
          }
        },
        GridInfo: {},
        Events: {
          EventRaised: "Submitted", // Saved, Submitted, Cancelled, AutoCompletionTextChanged,
          PageToNavigateWhenSubmitted: "" // We can go back to dashboard or stay on the Same page or to a specific page
        },
        ValidationInfo: {},
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: ""
          }
        ],
        Masters: {},
        Modal: {},
        CharRestrict: {}
      }
    };
  },
  mounted() {},
  methods: {
    Verify() {
      console.log(this.OTP.DataModel.Data);
      let vm = this;
      if (
        Utilities.IsNotNullOrEmptyOrUndefined(vm.OTP.DataModel.Data.OTP.OTP)
      ) {
        this.OTP.DataModel.Data.CreatedBy = new Date();
        this.OTP.DataModel.Data.CRUD = "OTPValidate";
        this.OTP.DataModel.Data.Token = "New";
        this.OTP.DataModel.Data.OTP.RegistrationId = sessionStorage.getItem(
          "RegistrationId"
        );
        var dataString = JSON.stringify(this.OTP.DataModel.Data);
        axios
          .post("APIScript/PHP/APIService/OTP/OTP.php", dataString)
          .then(function(response) {
            if (response.data.ErrorInfo == null) {
              Utilities.gotoRoute(vm, "/login");
            } else if (response.data.ErrorInfo == "Invalid OTP") {
              vm.$swal.fire("Oops", "Something went worng", "error");
            } else if (response.data.ErrorInfo != "Invalid OTP") {
              Utilities.gotoRoute(vm, "/login");
            } else {
              if (
                !Utilities.IsNotNullOrEmptyOrUndefined(
                  vm.OTP.DataModel.Data.OTP.OTP
                )
              ) {
                console.log(response.data.ErrorInfo);
                vm.$swal.fire(
                  "Information missing",
                  "Please provide OTP ",
                  "error"
                );
              } else if (response.data.ErrorInfo != null) {
                console.log(response.data.ErrorInfo);
                vm.$swal.fire("Oops...", "Incorrect OTP !", "error");
              }
            }
          })
          .catch(function(response) {
            console.log(response);
            vm.$swal.fire("Oops", "Something went worng", "error");
          });
      } else {
        vm.$swal.fire("Information missing", "Please provide OTP", "error");
      }
    },
    forgetpasswordClick() {
      Utilities.gotoRoute(this, "/ForgotPassword");
    },
    Register() {
      Utilities.gotoRoute(this, "/Registration");
    },
    Pay() {
      console.log("test");
      var options = {
        key: "YOUR_KEY_ID",
        amount: "2000", // 2000 paise = INR 20
        name: "Merchant Name",
        description: "Purchase Description",
        image: "/your_logo.png",
        handler: function(response) {
          alert(response.razorpay_payment_id);
        },
        prefill: {
          name: "Gaurav Kumar",
          email: "test@test.com"
        },
        notes: {
          address: "Hello World"
        },
        theme: {
          color: "#F37254"
        }
      };
      var rzp1 = new Razorpay(options);
      rzp1.open();
    }
  }
};
</script>

<style scoped>
.header-Panel {
  /* background-color:#00ff9c ; */
  /* #00ff9c */
}
.OTPClass {
  margin-left: 160px;
}
.h-80 {
  height: 80% !important;
}

#partitioned {
  padding-left: 15px;
  letter-spacing: 42px;
  border: 0;
  background-image: linear-gradient(
    to left,
    black 70%,
    rgba(255, 255, 255, 0) 0%
  );
  background-position: bottom;
  background-size: 50px 1px;
  background-repeat: repeat-x;
  background-position-x: 35px;
  width: 220px;
  min-width: 220px;
}

#divInner {
  left: 0;
  position: sticky;
}

#divOuter {
  width: 190px;
  overflow: hidden;
  margin-left: 45px;
}
</style>
